import React, { useState, useRef, useMemo } from "react";
import JoditEditor from "jodit-react";

const ICPCJoditEditor = ({ placeholder, readOnly, data, onChange }) => {
  const editor = useRef(null);
  const [content, setContent] = useState(data);

  return useMemo(
    () => (
      <JoditEditor
        ref={editor}
        value={content}
        config={{
          toolbarStickyOffset: 75,
          readonly: readOnly ? readOnly : false,
          placeholder: placeholder || "Start typing...",
        }}
        tabIndex={1}
        onBlur={(newContent) => setContent(newContent)}
        onChange={onChange}
      />
    ),
    []
  );
};

export default ICPCJoditEditor;
